// --- React
import { createContext } from "react";

/**
 * DialogsCtx Context
 *
 * This context provides the structure for managing dialog states and actions.
 * It includes the dialogs array, form state, and actions for opening and closing dialogs.
 *
 */
export const DialogsCtx = createContext({
  dialogs: [],
  form: {
    state: {},
    isValid: true,
  },
  actions: {
    openDialog: () => {},
    closeDialog: () => {},
  },
});
